'use strict';
import { EventEmitter } from 'events';
import { Decoder, Encoder, Reader, tools } from 'ts-ebml';
import { blobToArrayBuffer, setCodecScore } from './recordMediaHelper.js';
const RECORDING_TIME = 5000;
const TIME_WINDOW = 8;
const STRIDE = 4;
export default class CodecTester extends EventEmitter {
	constructor() {
		if (CodecTester._instance) {
			//singleton class
			return CodecTester._instance;
		}
		super();
		CodecTester._instance = this;
		/* Properties */
		this.mediaRecorder = {};
		this.streams = {};
		this.startTime = {};
		this.endTime = {};
		this.trackIds = [];
		this.testerId = (Math.random() + 1).toString(36).substring(5);
		this.initializing = false;
		/**** METHODS *****/
		this.initDevice = this.initDevice.bind(this);
		this.start = this.start.bind(this);
		this.stop = this.stop.bind(this);
		this.analyzeRecording = this.analyzeRecording.bind(this);
		this.clearRecorder = this.clearRecorder.bind(this);
		this.onDataAvailable = this.onDataAvailable.bind(this);
		this.onRecorderStop = this.onRecorderStop.bind(this);
		this.onRecorderStart = this.onRecorderStart.bind(this);

		this.terminate = this.terminate.bind(this);
	}

	async initDevice(track, options) {
		/*await new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, Math.random() * 100);
		});*/

		if (this.trackIds.indexOf(track.id) != -1) {
			return;
		}
		this.trackIds.push(track.id);
		//if (this.initializing) return;
		//this.initializing = true;
		//console.log('init device with ', track);
		/*if (this.mediaRecorder && this.mediaRecorder.state == 'active') {
			this.mediaRecorder.stop();
		}*/
		let id = (Math.random() + 1).toString(36).substring(5);
		let id2 = (Math.random() + 1).toString(36).substring(5);
		this.streams[id] = await new MediaStream([track]);
		try {
			this.mediaRecorder[id] = new MediaRecorder(this.streams[id], {
				mimeType: `video/webm;codecs=vp8`,
				videoBitsPerSecond: 10000000,
			});
			this.mediaRecorder[id].id = id;
			this.mediaRecorder[id].codec = 'vp8';

			this.mediaRecorder[id2] = new MediaRecorder(this.streams[id], {
				mimeType: `video/webm;codecs=avc1.640034`,
				videoBitsPerSecond: 10000000,
			});
			this.mediaRecorder[id2].id = id2;
			this.mediaRecorder[id2].codec = 'avc1';
		} catch (e) {
			console.log('init error', e);
		}
		for (let recorder in this.mediaRecorder) {
			this.mediaRecorder[recorder].ondataavailable = this.onDataAvailable;
			this.mediaRecorder[recorder].onstop = this.onRecorderStop;
			//this.mediaRecorder.onerror = this.onRecorderError;
			this.mediaRecorder[recorder].onstart = this.onRecorderStart;
			this.start(recorder);
		}
		//this.initializing = false;
	}

	clearRecorder(id) {
		if (this.streams[id] != null) {
			delete this.streams[id];
		}
		if (this.mediaRecorder[id] != null) {
			if (this.mediaRecorder[id].state == 'active') {
				this.mediaRecorder[id].stop();
			}
			this.mediaRecorder[id].ondataavailable = null;
			this.mediaRecorder[id].onstop = null;
			//this.mediaRecorder.onerror = this.onRecorderError;
			this.mediaRecorder[id].onstart = null;
			delete this.mediaRecorder[id];
		}
	}

	stop(id) {
		if (this.mediaRecorder[id] != null) {
			if (this.mediaRecorder[id].state == 'recording') {
				this.mediaRecorder[id].stop();
			}
		}
	}
	start(id) {
		if (this.mediaRecorder[id] != null && this.mediaRecorder[id].state != 'recording') {
			try {
				this.mediaRecorder[id].start();

				setTimeout(() => {
					//console.log('timeout for recorder');
					this.stop(id);
				}, RECORDING_TIME);
			} catch (err) {
				console.log('start error', err);
			}
		}
	}

	onDataAvailable(e) {
		//console.log('on data available', e);
		let decoder = new Decoder();
		let deltas = [];
		let minFramerate = 1000;
		let totalBlocks = 0;
		let totalKeyframeSize = 0;
		blobToArrayBuffer(e.data).then((buf) => {
			let elms;
			try {
				elms = decoder.decode(buf);
			} catch (err) {
				//TODO:decide what to do when can't decode
			}
			let entities = Object.keys(elms);
			let lastTc = 0;
			let firstBlock = true;
			let timestamp = null;
			let colorMatrix = false;
			for (let i = 0; i < entities.length; i++) {
				let elm = elms[entities[i]];
				if (elm.EBML_ID == '55b0') {
					colorMatrix = true;
				}
				if (elm.name == 'Cluster') {
					firstBlock = true;
					continue;
				}
				if (elm.name == 'Timecode') {
					timestamp = elm.value;
					continue;
				}
				if (elm.name == 'SimpleBlock') {
					const block = tools.ebmlBlock(elm.data);
					if (block.keyframe) {
						totalBlocks++;
						totalKeyframeSize += block.frames[0].length;
					}
					let timecode = block.timecode;
					if (firstBlock) {
						lastTc = timecode;
						firstBlock = false;
						continue;
					}

					let dt = timecode - lastTc;
					deltas.push(dt);

					lastTc = timecode;
				}
			}

			for (let i = 0; i < deltas.length - TIME_WINDOW; i += STRIDE) {
				let sum = 0;
				for (let j = 0; j < TIME_WINDOW; j++) {
					sum += deltas[i + j];
				}
				const avg = sum / TIME_WINDOW || 0;
				minFramerate = Math.min(minFramerate, 1000 / avg);
			}
			let expectedTime = this.endTime[e.target.id] - this.startTime[e.target.id];
			this.analyzeRecording({
				frameRate: minFramerate,
				lastTs: timestamp + lastTc,
				expectedTime,
				codec: e.target.codec,
				colorMatrix,
				keyframeSize: totalKeyframeSize / totalBlocks,
			});
		});
	}
	onRecorderStop(e) {
		this.endTime[e.target.id] = performance.now();
		//console.log('recorder stopped', e);
		this.clearRecorder(e.target.id);
	}

	onRecorderStart(e) {
		//console.log('ON RECORDER START');
		this.startTime[e.target.id] = performance.now();
	}

	analyzeRecording(data) {
		//console.log('analyze recording', data);
		let score = 10;

		let timeDiff = Math.abs(data.expectedTime - data.lastTs) / 1000;
		if (data.colorMatrix && data.codec == 'avc1') {
			score = 5;
		}
		if (data.frameRate < 24) {
			score--;
		}
		if (data.frameRate < 20) {
			score--;
		}
		if (data.frameRate < 16) {
			score -= 3;
		}

		score -= Math.round(timeDiff * 5);
		if (data.keyframeSize < 5000) {
			//this is most probably black screen
			score = -30;
		}

		setCodecScore(data.codec, score);
	}

	terminate() {
		for (let recorder in this.mediaRecorder) {
			this.clearRecorder(recorder);
		}
	}
}
